import { Link, useNavigate } from 'react-router-dom';
import { LogOut, LayoutDashboard, Home, UserCog } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from './LanguageToggle';

export const Navbar = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleLogout = () => {
    onLogout();
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 bg-[#0a0a0a] border-b border-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/admin-dashboard" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={'/brand/ast-logo-asb606-nav.png'}
              alt="ASB606 Logo"
              className="h-10 w-auto"
            />
            <div>
              <p className="text-lg font-bold text-white">ASB606</p>
              <p className="text-xs text-[#808080]">{language === 'ar' ? 'لوحة التحكم' : 'Control Panel'}</p>
            </div>
          </Link>

          {user && (
            <div className="flex items-center gap-4">
              <Link to="/">
                <Button variant="ghost" className="text-[#808080] hover:text-white hover:bg-[#1a1a1a]" data-testid="nav-home">
                  <Home className="h-4 w-4 me-2" />
                  {language === 'ar' ? 'الرئيسية' : 'Home'}
                </Button>
              </Link>
              <Link to="/admin-dashboard">
                <Button variant="ghost" className="text-[#808080] hover:text-white hover:bg-[#1a1a1a]" data-testid="nav-dashboard">
                  <LayoutDashboard className="h-4 w-4 me-2" />
                  {language === 'ar' ? 'لوحة التحكم' : 'Dashboard'}
                </Button>
              </Link>
              <Link to="/account-settings">
                <Button variant="ghost" className="text-[#808080] hover:text-white hover:bg-[#1a1a1a]" data-testid="nav-account">
                  <UserCog className="h-4 w-4 me-2" />
                  {language === 'ar' ? 'إدارة الحساب' : 'Account'}
                </Button>
              </Link>
              <span className="text-[#a0a0a0] font-medium">{user.name}</span>
              <span className="px-3 py-1 bg-[#c9a227] text-black text-xs font-semibold rounded-full">
                {user.role === 'admin' ? (language === 'ar' ? 'أدمن' : 'Admin') : (language === 'ar' ? 'موظف' : 'Staff')}
              </span>
              <LanguageToggle />
              <Button
                onClick={handleLogout}
                variant="outline"
                data-testid="logout-btn"
                className="border-[#333] text-[#a0a0a0] hover:bg-[#1a1a1a] hover:text-white hover:border-[#444]"
              >
                <LogOut className="h-4 w-4 me-2" />
                {language === 'ar' ? 'تسجيل خروج' : 'Logout'}
              </Button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
